import { render, staticRenderFns } from "./DailyPricesTemplate.vue?vue&type=template&id=60eb0a4e&scoped=true"
import script from "./DailyPricesTemplate.vue?vue&type=script&lang=js"
export * from "./DailyPricesTemplate.vue?vue&type=script&lang=js"
import style0 from "./DailyPricesTemplate.vue?vue&type=style&index=0&id=60eb0a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb0a4e",
  null
  
)

export default component.exports